module.exports = __webpack_public_path__ + "img/3-1.add54ed2.png";